import React from "react";
import './banner.css'

const Banner = () => {
  return (
    <div className="banner">
      <div id="_lg_form_ bg_none"></div>
      <div className="bg_banner"/>
      <div className="banner_logo">
        <div className="logo_content">FAST LOAN</div>
      </div>
    </div>
  );
};

export default Banner;
